"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trtcJsSdk = _interopRequireDefault(require("trtc-js-sdk"));
var test = function test() {
  var uplinkClient = null; // 用于检测上行网络质量
  var downlinkClient = null; // 用于检测下行网络质量
  var localStream = null; // 用于测试的流
  var testResult = {
    // 记录上行网络质量数据
    uplinkNetworkQualities: [],
    // 记录下行网络质量数据
    downlinkNetworkQualities: [],
    average: {
      uplinkNetworkQuality: 0,
      downlinkNetworkQuality: 0
    }
  };
  // 1. 检测上行网络质量
  function testUplinkNetworkQuality() {
    return _testUplinkNetworkQuality.apply(this, arguments);
  } // 2. 检测下行网络质量
  function _testUplinkNetworkQuality() {
    _testUplinkNetworkQuality = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            uplinkClient = _trtcJsSdk.default.createClient({
              sdkAppId: 0,
              // 填写 sdkAppId
              userId: 'user_uplink_test',
              userSig: '',
              // uplink_test 的 userSig
              mode: 'rtc'
            });
            localStream = _trtcJsSdk.default.createStream({
              audio: true,
              video: true
            });
            // 根据实际业务场景设置 video profile
            localStream.setVideoProfile('480p');
            _context.next = 5;
            return localStream.initialize();
          case 5:
            uplinkClient.on('network-quality', function (event) {
              var uplinkNetworkQuality = event.uplinkNetworkQuality;
              testResult.uplinkNetworkQualities.push(uplinkNetworkQuality);
            });
            // 加入用于测试的房间，房间号需要随机，避免冲突
            _context.next = 8;
            return uplinkClient.join({
              roomId: 8080
            });
          case 8:
            _context.next = 10;
            return uplinkClient.publish(localStream);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _testUplinkNetworkQuality.apply(this, arguments);
  }
  function testDownlinkNetworkQuality() {
    return _testDownlinkNetworkQuality.apply(this, arguments);
  } // 3. 开始检测
  function _testDownlinkNetworkQuality() {
    _testDownlinkNetworkQuality = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            downlinkClient = _trtcJsSdk.default.createClient({
              sdkAppId: 0,
              // 填写 sdkAppId
              userId: 'user_downlink_test',
              userSig: '',
              // userSig
              mode: 'rtc'
            });
            downlinkClient.on('stream-added', /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(event) {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return downlinkClient.subscribe(event.stream, {
                        audio: true,
                        video: true
                      });
                    case 2:
                      // 订阅成功后开始监听网络质量事件
                      downlinkClient.on('network-quality', function (event) {
                        var downlinkNetworkQuality = event.downlinkNetworkQuality;
                        testResult.downlinkNetworkQualities.push(downlinkNetworkQuality);
                      });
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
            // 加入用于测试的房间，房间号需要随机，避免冲突
            _context3.next = 4;
            return downlinkClient.join({
              roomId: 8080
            });
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _testDownlinkNetworkQuality.apply(this, arguments);
  }
  testUplinkNetworkQuality();
  testDownlinkNetworkQuality();
  // 4. 15s 后停止检测，计算平均网络质量
  setTimeout(function () {
    // 计算上行平均网络质量
    if (testResult.uplinkNetworkQualities.length > 0) {
      testResult.average.uplinkNetworkQuality = Math.ceil(testResult.uplinkNetworkQualities.reduce(function (value, current) {
        return value + current;
      }, 0) / testResult.uplinkNetworkQualities.length);
    }
    if (testResult.downlinkNetworkQualities.length > 0) {
      // 计算下行平均网络质量
      testResult.average.downlinkNetworkQuality = Math.ceil(testResult.downlinkNetworkQualities.reduce(function (value, current) {
        return value + current;
      }, 0) / testResult.downlinkNetworkQualities.length);
    }
    // 检测结束，清理相关状态。
    uplinkClient.leave();
    downlinkClient.leave();
    localStream.close();
  }, 15 * 1000);
};

// 数值	含义
// 0	网络状况未知，表示当前 client 实例还没有建立上行/下行连接
// 1	网络状况极佳
// 2	网络状况较好
// 3	网络状况一般
// 4	网络状况差
// 5	网络状况极差
// 6	网络连接已断开 注意：若下行网络质量为此值，则表示所有下行连接都断开了